module.exports = __webpack_public_path__ + "static/media/todoList.ea7e4d70.png";